import React from 'react';
import { EmptyState } from '../widgets';
import css from './ReportsNoData.css';

function ReportsNoData() {
    return (
        <div className={css.midContainer}>
            <div className={css.noDataContainer}>
                <EmptyState
                    icon="noData"
                    header="STATIC.PAGES.REPORTS.REPORT_NO_DATA_TITLE"
                    subHeader="STATIC.PAGES.REPORTS.REPORT_NO_DATA_SUB_TITLE"
                />
            </div>
        </div>
    );
}

export default ReportsNoData;
